export default __webpack_public_path__ + "static/media/category_21.c2b245b8.png";